import type { TableRowType } from '../components/editor/grid/reduxStore/table.types';
import { TotalRowTypesIdentifier } from '../components/editor/grid/reduxStore/table.types';
import { TableRowDefaultClassNamesEnum } from '../components/editor/grid/reduxStore/tableRowDefaultStyleSlice.ts';

export const isRowBelongsToTotal = (row) => Object.values(TotalRowTypesIdentifier).includes(row.rowType);

export const getRowClassName = (rowType: string) => {
  const key = (rowType ?? '').toUpperCase();
  return TableRowDefaultClassNamesEnum[key as keyof typeof TableRowDefaultClassNamesEnum] || '';
};

export const isTaxOrDiscountRow = (row: TableRowType) =>
  row.rowType === TotalRowTypesIdentifier.TAX || row.rowType === TotalRowTypesIdentifier.DISCOUNT;

export const getRowAttributeName = (row: TableRowType): string => {
  const rowType = isTaxOrDiscountRow(row) ? TotalRowTypesIdentifier.SUBTOTAL : row.rowType;
  return `table_${rowType.toLowerCase()}_row`;
};
